export default {
  'component.homesettings.title': 'Hjemmeside rediger',
};
